import { useEffect } from "react";

import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $getRoot } from "lexical";
import { $generateNodesFromDOM } from "@lexical/html";

interface LoadInitialContentPluginProps {
  initialContent: string;
}

const LoadInitialContentPlugin = ({
  initialContent,
}: LoadInitialContentPluginProps) => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    if (editor.getEditorState()) {
      editor.update(() => {
        const root = $getRoot();
        root.clear();
        const parser = new DOMParser();
        const dom = parser.parseFromString(initialContent, "text/html");
        const nodes = $generateNodesFromDOM(editor, dom);
        for (const node of nodes) {
          root.append(node);
        }
      });
    }
  }, [initialContent]);

  return null;
};

export default LoadInitialContentPlugin;
